import { apolloClient } from "@/plugins/vue-apollo.js";

const updateGovernate = async (_variables) => {
    // , limit, skip
    let responseFromApi;
    let variables = _variables;
    // debugger
    responseFromApi = apolloClient
        .mutate({
            mutation: require("@/settings/api/mutations/governates/update_governate.graphql"),
            variables: variables,

            update: (store, { data }) => {
                const query = {
                    query: require("@/settings/api/queries/governates/governate_query.graphql"),
                    variables: {
                        input: {
                            limit: 10,
                            skip: 0
                        },
                        filter: {
                            searchKey: ''
                        }
                    },
                };
                let allGovernates = store.readQuery(query);
                const findIndex = allGovernates.getGovernates.areas.findIndex(
                    (item) => item._id === data.updateGovernate._id
                );
                findIndex !== -1 &&
                    allGovernates.getGovernates.governates.splice(
                        findIndex,
                        1,
                        data.updateGovernate
                    );
                store.writeQuery({
                    ...query,
                    data: allGovernates,
                });
            },
        })
        .catch((error) => {
            return error;
        });
    return responseFromApi;
};
export { updateGovernate };
